"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bibbona": {
    "ef3a60b4": [{
      "hkey": "a15c167c",
      "slug": "marina-di-bibbona",
      "name": "Marina di Bibbona",
      "primary": true,
      "skipSearch": false
    }],
    "forte-di-bibbona": [{
      "hkey": "a15c167c",
      "slug": "marina-di-bibbona",
      "name": "Marina di Bibbona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bibbona"
    }],
    "fcddb0d3": [{
      "hkey": "09c33a4f",
      "slug": "la-california-stazione-bibbona",
      "name": "La California-Stazione Bibbona",
      "primary": true,
      "skipSearch": false
    }],
    "la-california": [{
      "hkey": "09c33a4f",
      "slug": "la-california-stazione-bibbona",
      "name": "La California-Stazione Bibbona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;